// Метаданные кухонь для UI: русские названия + какие выносить полками на главный.
// Серверные ключи cuisine (9, см. backend CUISINES) → витринные названия.
export const CUISINE_LABELS: Record<string, string> = {
  russian: 'Русская кухня',
  caucasian: 'Кавказская кухня',
  central_asian: 'Среднеазиатская кухня',
  georgian: 'Грузинская кухня',
  ukrainian: 'Украинская кухня',
  italian: 'Итальянская кухня',
  asian: 'Азиатская кухня',
  european: 'Европейская кухня',
  other: 'Разное',
  chechen: 'Чеченская кухня',
  uzbek: 'Узбекская кухня',
  azerbaijani: 'Азербайджанская кухня',
};

export function cuisineLabel(key: string): string {
  return CUISINE_LABELS[key] ?? 'Кухня';
}

// На главный выносим полки только для кухонь с достаточным числом рецептов,
// КРОМЕ размытых корзин (european — «всё западное», other — «не определено»):
// культурной полки из них не выходит (решение Идриса 03.06). Они доступны
// через рекомендации/планировщик и прямой браузер кухни.
const HOME_SHELF_MIN = 6;
const HOME_HIDDEN = new Set(['other', 'european']);

export interface CuisineShelfMeta {
  key: string;
  label: string;
  count: number;
}

// getCuisines() приходит отсортированным по убыванию count (бэкенд) — порядок сохраняем.
export function homeShelfCuisines(
  list: Array<{ cuisine: string; count: number }>,
): CuisineShelfMeta[] {
  return list
    .filter((c) => c.count >= HOME_SHELF_MIN && !HOME_HIDDEN.has(c.cuisine))
    .map((c) => ({ key: c.cuisine, label: cuisineLabel(c.cuisine), count: c.count }));
}
